module.exports = __webpack_public_path__ + "static/media/home-hero.087668a4.png";